import React from 'react';
import PropTypes from 'prop-types';
import {Toggle, Cart, ArrowUp, ArrowDown} from './ToggleButton.style';

export const ToggleButton = props => {
  const arrow = props.isArrowDown ? <ArrowDown /> : <ArrowUp />;
  return (
    <Toggle data-rw="menu-page--basket--toggle-button">
      {arrow}
      <Cart arrowDown={props.isArrowDown} />
    </Toggle>
  );
};

ToggleButton.propTypes = {
  isArrowDown: PropTypes.bool.isRequired
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./components/BasketBar/ToggleButton.js